<script>
    import SelectFilter from "./select-filter";

    export default {
        extends: SelectFilter,

        computed: {
            /**
             * @return {String|null}
             */
            dependsOnKey() {
                return _.get(this.data, 'dependsOn', null);
            },

            /**
             * @return {String|null}
             */
            dependOnLocalKey() {
                return _.get(this.data, 'dependsOnLocal', this.dependsOnKey);
            },

            /**
             * @return {*}
             */
            dependOnValue() {
                return _.get(this.pendingValues, this.dependsOnKey);
            },

            /**
             * @return {Boolean}
             */
            options() {
                const options = _.get(this.data, 'options', []);
                if (!this.dependOnValue) {
                    return options;
                }

                return _.filter(options, {[this.dependOnLocalKey]: this.dependOnValue});
            },
        },

        watch: {
            dependOnValue(value) {
                value && this.onChange(null);
            },
        },
    }
</script>
